/** HOT = volume >= 2x the median of the visible set (presentational, no API flag). */
export const hotThreshold = (vols: number[]) => {
  if (!vols.length) return Infinity;
  const sorted = [...vols].sort((a, b) => a - b);
  const median = sorted[Math.floor(sorted.length / 2)];
  return median * 2;
};

/**
 * Zero volume is never hot: pre-launch lists are mostly zeros, which drags the
 * median (and threshold) to 0 — a bare `vol >= threshold` then marks EVERY
 * card hot and the chip means nothing.
 */
export const isHotVolume = (volume: number, threshold: number) => volume > 0 && volume >= threshold;
